import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import { GET_PIN_FAILURE, GET_PIN_REQUEST, GET_PIN_SUCCESS } from 'salon/constants';

const getPin = ({ salonId, stylistId }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    types: [GET_PIN_REQUEST, GET_PIN_SUCCESS, GET_PIN_FAILURE],
    config: {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    endpoint: `salon/v2/${salonId}/stylist/pin/${stylistId}/`,
  },
});

// noinspection JSUnusedGlobalSymbols
export default getPin;
